import React, { FC } from 'react';

import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';

import { useUserData } from 'context';
import { STATUS_NAME } from 'enums';
import { openCookieSettings } from 'lib/consent';
import { PATHS, VoidFunctionNoArgs } from 'types';
import { logoutUser } from 'utils';
import { Menu } from 'views/components';
import { ThemeSwitcher } from 'views/components/ThemeSwitcher/ThemeSwitcher';

interface IUserMenuProps {
  anchorEl: HTMLElement;
  handleClose: VoidFunctionNoArgs;
}

const UserMenu: FC<IUserMenuProps> = props => {
  const { anchorEl, handleClose } = props;
  const { setUser, setCurrentOrganization, user } = useUserData();
  const displayName = [user?.firstName, user?.lastName].filter(Boolean).join(' ');

  const onLogOutClick = (): void => {
    logoutUser(setUser, setCurrentOrganization);
  };

  const onCookieSettingsClick = (): void => {
    handleClose();
    openCookieSettings();
  };

  return (
    <Menu
      anchorEl={anchorEl}
      onClose={handleClose}
      placement="bottom-end"
      mode="content"
      appearance="inset"
      size="medium"
      title={displayName || user?.email}
      description={displayName ? user?.email : undefined}
      identityGap="none"
      footer={<ThemeSwitcher inline />}
    >
      <Menu.Items>
        {user?.requestStatus !== STATUS_NAME.PENDING && (
          <Menu.Item>
            <Link
              onClick={handleClose}
              to={{
                pathname: `${PATHS.USER_PROFILE}/${user?.id}`,
              }}
            >
              <FormattedMessage id="user-menu.item.my-profile" />
            </Link>
          </Menu.Item>
        )}
        <Menu.Item>
          <Link onClick={handleClose} to={PATHS.PROFILE_SETTINGS_GENERAL_DATA}>
            <FormattedMessage id="user-menu.item.profile-settings" />
          </Link>
        </Menu.Item>
        <Menu.Item onClick={onCookieSettingsClick}>
          <FormattedMessage id="user-menu.item.cookie-settings" />
        </Menu.Item>
        <Menu.Item onClick={onLogOutClick}>
          <FormattedMessage id="user-menu.item.log-out" />
        </Menu.Item>
      </Menu.Items>
    </Menu>
  );
};

export { UserMenu };
